export default __webpack_public_path__ + "static/media/q9_step3.e2b55c83.png";